import { FormFormattedField } from 'components/Form';
import { Field, useField } from 'react-final-form';
import { normalizeFormattedField } from 'utils';
import { useIsAlternativeAuctionSelected } from '../hooks/useIsAlternativeAuctionSelected';
import { useCallback } from 'react';
import { useCounterReserveBalancer } from 'hooks/useCounterReserveBalancer';
import { composeValidators, required } from 'utils/validators';

type Props = {
  vehicleId: number;
};

const counterValidation = (value: any, formValues: any) => {
  if (typeof value === 'string') {
    value.trim();
  }

  const isAlternativeAuction = formValues.auctionId?.label && !formValues.auctionId.label.startsWith('#AA');
  const isScAuction = formValues.auctionId?.label && formValues.auctionId.label.startsWith('#SC');

  if (!value) {
    return isScAuction ? 'Required' : undefined;
  }

  const parsed = typeof value === 'number' ? value : Number(value.trim());

  if (parsed % 100 !== 0) {
    return 'Counter should be divisible by 100';
  }

  if (!isAlternativeAuction) return;

  const currentReserve = formValues.reserve_price ? Number(formValues.reserve_price) : null;

  if (currentReserve && currentReserve > parsed) {
    return 'Counter should be equal or greater than reserve';
  }

  return undefined;
};

export const AACounterField = ({ vehicleId }: Props) => {
  const isAlternativeAuction = useIsAlternativeAuctionSelected(vehicleId);

  const {
    input: { value: reservePrice, onChange: changeReserve }
  } = useField('reserve_price');

  const {
    input: { value: aaCounter, onChange: changeCounter }
  } = useField('aaCounter');

  const updateReserve = useCallback((reserve: number) => changeReserve(reserve), []);
  const updateCounter = useCallback((counter: number) => changeCounter(counter), []);

  useCounterReserveBalancer(Number(reservePrice) || 0, Number(aaCounter) || 0, updateReserve, updateCounter, {
    skip: !isAlternativeAuction
  });

  // const counterValidation = useCounterValidator(auctionType);

  return (
    <Field
      name="aaCounter"
      component={FormFormattedField}
      parse={normalizeFormattedField}
      prefix="$"
      thousandSeparator
      placeholder="-"
      validate={counterValidation}
      label="Counter to buyers"
      styleVariant="filled"
    />
  );
};
